import { useTranslation } from "react-i18next";
import * as yup from "yup";

export const appl78ValidationSchema = () => {
  const { t } = useTranslation();
  return yup
    .object()
    .shape({
      acceptedFinancialReport: yup
        .string()
        .required(t("Το πεδίο είναι υποχρεωτικό")),
      pastApp: yup
        .object()
        .shape({ m02_id: yup.string(), label: yup.string() })
        .nullable()
        .default(undefined)
        .transform((value, originalValue) => {
          if (
            originalValue &&
            typeof originalValue === "object" &&
            Object.keys(originalValue).length === 0
          ) {
            return undefined;
          }
          return value;
        }),
      d50_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
      boardDate: yup
        .date()
        .required(t("Το πεδίο είναι υποχρεωτικό"))
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
      fudocPrakt1: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
      usageFromDate: yup.date().required(t("Το πεδίο είναι υποχρεωτικό")),
      usageToDate: yup.date().required(t("Το πεδίο είναι υποχρεωτικό")),
      fudocWeb: yup.string(),
      webDate: yup
        .date()
        .nullable()
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
      webURL: yup.string().url(),
      paperDate: yup
        .date()
        .nullable()
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
      paperName: yup.string(),
      fudocPaper: yup.string(),
      totalActive: yup
        .string()
        .required(t("Το πεδίο είναι υποχρεωτικό"))
        .matches(
          /^[0-9]*(\.)?[0-9]{0,2}$/,
          `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        ),
      businessCircle: yup
        .string()
        .required(t("Το πεδίο είναι υποχρεωτικό"))
        .matches(
          /^(-)?[0-9]+(\.)?[0-9]{0,2}$/,
          `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        ),
      employees: yup
        .string()
        .required(t("Το πεδίο είναι υποχρεωτικό"))
        .matches(
          /^[0-9]*(\.)?[0-9]{0,2}$/,
          `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        ),
      assets: yup.string().matches(/^[0-9]*(\.)?[0-9]{0,2}$/, {
        message: `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        excludeEmptyString: true,
      }),
      reserves: yup.string().matches(/^[0-9]*(\.)?[0-9]{0,2}$/, {
        message: `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        excludeEmptyString: true,
      }),
      requirements: yup.string().matches(/^[0-9]*(\.)?[0-9]{0,2}$/, {
        message: `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        excludeEmptyString: true,
      }),
      prepayments: yup.string().matches(/^[0-9]*(\.)?[0-9]{0,2}$/, {
        message: `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        excludeEmptyString: true,
      }),
      equityTotal: yup.string().matches(/^(-)?[0-9]+(\.)?[0-9]{0,2}$/, {
        message: `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        excludeEmptyString: true,
      }),
      obligationsTotal: yup.string().matches(/^[0-9]*(\.)?[0-9]{0,2}$/, {
        message: `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        excludeEmptyString: true,
      }),
      internationalAccounting: yup.string().nullable(),
      singleFile: yup.string().nullable(),
      resultsNoTax: yup.string().matches(/^(-)?[0-9]+(\.)?[0-9]{0,2}$/, {
        message: `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        excludeEmptyString: true,
      }),
      category: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
      fudocShortEconomicData: yup.string().nullable(),
      fudocAnnualEkthesi: yup
        .string()
        .nullable()
        .when(["internationalAccounting"], {
          is: (internationalAccounting: string) => {
            return !!internationalAccounting;
          },
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
          otherwise: (schema) => schema,
        }),
      fudocEkthesi: yup
        .string()
        .nullable()
        .when(["internationalAccounting", "singleFile", "category"], {
          is: (
            internationalAccounting: string,
            singleFile: string,
            category: string,
          ) =>
            !internationalAccounting &&
            ((!!singleFile && category !== "very small") ||
              (!singleFile && ["small", "medium", "big"].includes(category))),
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
          otherwise: (schema) => schema,
        }),

      fudocEkthesiElegkton: yup
        .string()
        .nullable()
        .when(["internationalAccounting", "category"], {
          is: (internationalAccounting: string, category: string) =>
            !internationalAccounting && ["medium", "big"].includes(category),
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
          otherwise: (schema) => schema,
        }),

      fudocOikonomikesKatastasis: yup
        .string()
        .nullable()
        .when(["internationalAccounting", "singleFile"], {
          is: (internationalAccounting: string, singleFile: string) =>
            !internationalAccounting && !!singleFile,
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
          otherwise: (schema) => schema,
        }),

      fudocIsologismos: yup
        .string()
        .nullable()
        .when(["internationalAccounting", "singleFile", "category"], {
          is: (
            internationalAccounting: string,
            singleFile: string,
            category: string,
          ) => {
            return !!category && !internationalAccounting && !singleFile;
          },
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
          otherwise: (schema) => schema,
        }),

      fudocKatastasiApotelesmaton: yup
        .string()
        .nullable()
        .when(["internationalAccounting", "singleFile", "category"], {
          is: (
            internationalAccounting: string,
            singleFile: string,
            category: string,
          ) => {
            return !!category && !internationalAccounting && !singleFile;
          },
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
          otherwise: (schema) => schema,
        }),

      fudocProsartima: yup
        .string()
        .nullable()
        .when(
          ["internationalAccounting", "singleFile"],
          ([internationalAccounting, singleFile], schema) => {
            if (!!internationalAccounting || !!singleFile) {
              return schema.notRequired();
            } else {
              return schema.required(t("Το πεδίο είναι υποχρεωτικό"));
            }
          },
        ),

      fudocKatastasiMetabolon: yup
        .string()
        .nullable()
        .when(["internationalAccounting", "singleFile", "category"], {
          is: (
            internationalAccounting: string,
            singleFile: string,
            category: string,
          ) => {
            return (
              !internationalAccounting &&
              !singleFile &&
              ["medium", "big"].includes(category)
            );
          },
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
          otherwise: (schema) => schema,
        }),

      fudocKatastasiXrimatoroon: yup
        .string()
        .nullable()
        .when(["internationalAccounting", "singleFile", "category"], {
          is: (
            internationalAccounting: string,
            singleFile: string,
            category: string,
          ) =>
            !internationalAccounting &&
            !singleFile &&
            ["big"].includes(category),
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
          otherwise: (schema) => schema,
        }),
    })
    .test(
      "has filled all of website",
      t(
        "Εάν επιθυμείτε να εισάγετε τα στοιχεία της ιστοσελίδας, πρέπει να συμπληρώσετε όλα τα αντίστοιχα πεδία.",
      ),
      function (value) {
        if (!value || typeof value !== "object") {
          return true;
        }

        const fudocWeb = value.fudocWeb?.trim() || null;
        const webDate = value.webDate ?? null;
        const webURL = value.webURL?.trim() || null;

        if (!fudocWeb && !webDate && !webURL) {
          return true;
        }

        let hasError = false;

        if (!fudocWeb) {
          hasError = true;
          this.createError({
            path: "fudocWeb",
            message: t(
              "Εάν επιθυμείτε να εισάγετε τα στοιχεία της ιστοσελίδας, πρέπει να συμπληρώσετε όλα τα αντίστοιχα πεδία.",
            ),
          });
        }
        if (!webDate) {
          hasError = true;
          this.createError({
            path: "webDate",
            message: t(
              "Εάν επιθυμείτε να εισάγετε τα στοιχεία της ιστοσελίδας, πρέπει να συμπληρώσετε όλα τα αντίστοιχα πεδία.",
            ),
          });
        }
        if (!webURL) {
          hasError = true;
          this.createError({
            path: "webURL",
            message: t(
              "Εάν επιθυμείτε να εισάγετε τα στοιχεία της ιστοσελίδας, πρέπει να συμπληρώσετε όλα τα αντίστοιχα πεδία.",
            ),
          });
        }

        return hasError ? false : true;
      },
    )

    .test(
      "has filled all of paper",
      t(
        "Εάν επιθυμείτε να εισάγετε τα στοιχεία της εφημερίδας, πρέπει να συμπληρώσετε όλα τα αντίστοιχα πεδία.",
      ),
      function (value) {
        if (!value || typeof value !== "object") {
          return true;
        }

        const fudocPaper = value.fudocPaper?.trim() || null;
        const paperDate = value.paperDate ?? null;
        const paperName = value.paperName?.trim() || null;

        if (!fudocPaper && !paperDate && !paperName) {
          return true;
        }

        let hasError = false;

        if (!fudocPaper) {
          hasError = true;
          this.createError({
            path: "fudocPaper",
            message: t(
              "Εάν επιθυμείτε να εισάγετε τα στοιχεία της εφημερίδας, πρέπει να συμπληρώσετε όλα τα αντίστοιχα πεδία.",
            ),
          });
        }
        if (!paperDate) {
          hasError = true;
          this.createError({
            path: "paperDate",
            message: t(
              "Εάν επιθυμείτε να εισάγετε τα στοιχεία της εφημερίδας, πρέπει να συμπληρώσετε όλα τα αντίστοιχα πεδία.",
            ),
          });
        }
        if (!paperName) {
          hasError = true;
          this.createError({
            path: "paperName",
            message: t(
              "Εάν επιθυμείτε να εισάγετε τα στοιχεία της εφημερίδας, πρέπει να συμπληρώσετε όλα τα αντίστοιχα πεδία.",
            ),
          });
        }

        return hasError ? false : true;
      },
    );
};
